/*@flow*/
import { createStorage } from 'lib/localStorage';

const checkSupport = storage => {
  const testKey = '__some_random_key_you_are_not_going_to_use__';
  storage.setItem(testKey, testKey);
  storage.removeItem(testKey);
};

let _localStorage: any;
try {
  _localStorage = window.localStorage;
  checkSupport(_localStorage);
} catch (_) {
  _localStorage = createStorage();
}

let _sessionStorage: any;
try {
  _sessionStorage = window.sessionStorage;
  checkSupport(_sessionStorage);
} catch (_) {
  _sessionStorage = createStorage();
}
export const local = _localStorage;
export const session = _sessionStorage;
